import { FeatureFlag, Size } from '@ps/web-core-enums';
import { generatePath } from '@ps/web-core-utils';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router';
import { useLocation } from 'react-router-dom';

import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

import bottomSwiggleMobilePNG from '../../assets/bottom-swiggle-mobile.png';
import bottomSwiggleMobile from '../../assets/bottom-swiggle-mobile.webp';
import bottomSwigglePNG from '../../assets/bottom-swiggle.png';
import bottomSwiggle from '../../assets/bottom-swiggle.webp';
import useInitialLoading from '../../hooks/useInitialLoading';
import Content from '../Content/Content';
import Invite from '../Invite/Invite';
import JoinAndCreateClubToast from '../JoinAndCreateClubToast/JoinAndCreateClubToast';
import SidebarNav from '../Nav/SidebarNav/SidebarNav';
import SplitClubsSidebarNav from '../Nav/SidebarNav/SplitClubsSidebarNav';
import Promotion from '../Promotion/Promotion';

import styles from './Layout.scss';
import LayoutSkeleton from './LayoutSkeleton';

const Layout: React.FC = () => {
  const { greaterThan } = useScreenSize();
  const location = useLocation();
  const path = location.pathname;
  const isWall = path.includes('/wall');
  const isMobileDevice = !greaterThan(Size.Medium);
  const loading = useInitialLoading();
  const { homeGamesInvite = '', homeGamesPromotion = '' } = useSelector(select.cms.getAliases);
  const promoPath = generatePath(homeGamesPromotion, { clubId: ':clubId', clubName: ':clubName' });
  const invitePath = generatePath(homeGamesInvite, {});
  const isSplitClubsSidebarEnabled = useFeature(FeatureFlag.PKRHomeGamesNewSideBar);

  return (
    <div className={styles.layout}>
      {loading ? (
        <>
          {!!promoPath && <Route path={promoPath} component={Promotion} />}
          <LayoutSkeleton />
        </>
      ) : (
        <>
          <Route path={invitePath} component={Invite} />
          <div
            className={classNames(styles.sidebar, {
              [styles.splitClubsSidebar]: isSplitClubsSidebarEnabled
            })}
          >
            {isSplitClubsSidebarEnabled ? <SplitClubsSidebarNav /> : <SidebarNav />}
          </div>
          <div className={styles.content}>
            <JoinAndCreateClubToast />
            <Content />
            {!isWall && (
              <div className={styles.bottomDecoration}>
                {isMobileDevice ? (
                  <WebpWithFallback
                    src={bottomSwiggleMobile}
                    srcFallback={bottomSwiggleMobilePNG}
                  />
                ) : (
                  <WebpWithFallback src={bottomSwiggle} srcFallback={bottomSwigglePNG} />
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Layout;
